export default __webpack_public_path__ + "img/fQvbfaOv.28c444fc.svg";